



































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import Testimonial from './Testimonial.vue';

@Component({
  components: {
    Testimonial,
  }
})
export default class Testimonials extends Vue {
  @Prop({ default: true })
  private showTitle!: boolean;

  @Prop({ default: '' })
  private readonly customClass!: string;

  @Prop()
  private testimonials!: [];

  private current = 0;

  private prev () {
    const prev = this.current - 1;

    const eligiblePrev = prev < 0
      ? this.testimonials && this.testimonials.length - 1
      : prev;

    this.current = eligiblePrev;
  }

  private next () {
    const next = this.current + 1;

    const eligibleNext = next > this.testimonials.length - 1
      ? 0
      : next;

    this.current = eligibleNext;
  }
}
